import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

// 		{% set color = "red" %}

function isJson(value: string): boolean {
  try {
    return typeof JSON.parse(value) === 'object';
  } catch (e) {
    return false;
  }
}

export class SetValueBlock extends AbstractBlock {
  VAR_NAME = 'VAR_NAME';
  VALUE = 'VALUE';

  constructor() {
    super('logic_set_value_v2', t.to('変数に値をセット', 'value_set'));
  }

  override defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementShape(block);

    // フィールド
    const var_name = new Blockly.FieldTextInput('x');
    const value = new Blockly.FieldTextInput(t.to('数値や文字', 'set_value_default'));

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('変数', 'set_value1'))
      .appendField(var_name, this.VAR_NAME)
      .appendField(t.to('に値', 'set_value2'))
      .appendField(value, this.VALUE)
      .appendField(t.to('をセット', 'set_value3'));
  }

  override codeGenerateCore(block: BlockType): string {
    const varName = CodeSetting.getFieldValue(block, this.VAR_NAME);
    let value = CodeSetting.getFieldValue(block, this.VALUE); //getTrimCode(block,self.VALUE);
    let str = ''; // `typeof(${varName}) === "undefined" ? eval("${varName} = null") : "";`; //`typeof(${varName}) === "undefined" ? eval("var ${varName};") : "";`
    // json に変換できるか？（json は要素名を""でくくる）
    if (isJson(value)) {
      str += ` window.${varName} = ${value};`;
      // 数値に変換できるか？
    } else if (Number.isInteger(parseInt(value))) {
      str += ` window.${varName} = ${value};`;
      // true false はくくらない
    } else if (value === 'true' || value === 'false') {
      str += ` window.${varName} = ${value};`;
    } else if (!(value.indexOf('${') < 0)) {
      // 式であれば""をつけない。
      value = value.replace('${', '').replace('}', '');
      str += `  window.${varName} = ${value};`;
    } else {
      str += `  window.${varName} = "${value}";`;
    }
    return str;
  }
}
